import React from 'react';
import { CTAButton } from './CTAButton';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTA() {
  const ctas = ['Descubre el método que está haciendo que miles de niños vuelvan a hablar español sin presión.', 'Recupera el español en casa con estrategias probadas y simples.', 'Haz del español un idioma bonito, divertido y emocionalmente seguro.', 'Empieza hoy: tus hijos sí pueden hablar español contigo.'];
  return <section className="py-20 px-4 bg-gradient-to-br from-orange-500 via-amber-500 to-orange-600" data-id="element-16">
      <div className="max-w-4xl mx-auto text-center" data-id="element-17">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-12" data-id="element-18">
          📣 EL SIGUIENTE PASO ES SENCILLO
        </h2>

        <div className="space-y-6 mb-12" data-id="element-19">
          {ctas.map((cta, index) => <div key={index} className="flex items-start gap-4 bg-white/10 backdrop-blur-sm p-6 rounded-lg text-left" data-id="element-20">
              <ArrowRightIcon className="text-white flex-shrink-0 mt-1" size={24} data-id="element-21" />
              <p className="text-xl text-white font-medium" data-id="element-22">{cta}</p>
            </div>)}
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-2xl" data-id="element-23">
          <p className="text-2xl font-bold text-gray-900 mb-6" data-id="element-24">
            Tus hijos merecen crecer orgullosos de su herencia.
          </p>
          <p className="text-xl text-gray-700 mb-8" data-id="element-25">
            Y tú mereces disfrutar conversaciones en español con ellos.
          </p>
          <CTAButton size="large" data-id="element-26">Consigue Tu Guía Ahora</CTAButton>
          <p className="text-sm text-gray-600 mt-4" data-id="element-27">
            Empieza tu transformación hoy. El español puede volver a tu casa.
          </p>
        </div>
      </div>
    </section>;
}